import type { ErrorComponentProps } from '@tanstack/react-router'
import { Button, EmptyState } from '@volee/ui'

import { errorMessage } from '../messages/from-error.ts'
import { messages } from '../messages/index.ts'
import { Layout } from './layout.tsx'

/**
 * What is shown when a route's `beforeLoad` or `loader` throws.
 *
 * Without this the router shows its own default screen: English text and the raw exception
 * message. The commonest case is not even a bug — it is the backend being unreachable — and
 * it has to be said in Italian, from the message layer.
 *
 * `reset` reloads the route: for a network error that is the right move, because the user
 * only wants to try again.
 *
 * The shell is repeated in here: the root route's `errorComponent` replaces the whole tree,
 * so without `Layout` the error would land on a bare page, with no header and no navigation
 * to leave by.
 */
export function RouteError({ error, reset }: ErrorComponentProps) {
  return (
    <Layout>
      <EmptyState
        title={messages.error.title}
        description={errorMessage(error)}
        action={<Button onClick={reset}>{messages.error.retry}</Button>}
      />
    </Layout>
  )
}
